<template>
  <layout-report :renderBackAndForthFooter="false" :isProgressDone="true" :showFooter="false">
    <v-container class="padded">
      <v-row>
        <v-col cols="12">
          <v-card flat max-width="515">
            <v-card-title class="text-h4 px-0">
              {{ title }}
            </v-card-title>
            <v-card-subtitle class="pl-0">
              {{ description }}
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
      <thg-rating-form ratingKey="default" />
    </v-container>
  </layout-report>
</template>

<script lang="ts">
import ThgRatingForm from "@/components/rating/ThgRatingForm.vue";
import Debug from "@/components/utility/Debug.vue";
import LayoutReport from "@/layouts/LayoutReport.vue";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: { LayoutReport, Debug, ThgRatingForm }
})
export default class ThgRating extends Vue {
  get title() {
    return this.$t("report.thgRating.title");
  }

  get description() {
    return this.$t("report.thgRating.description");
  }

  get color() {
    return getDefaultPartnerColor();
  }
}
</script>
